import store from '../store'

const state = {
    status: localStorage.getItem('status') || '',
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('user') || [],
    raw_token: localStorage.getItem('raw_token') || '',
    companies: [],
    selected_company: '',
    selectedContact: '',
    selectedDepositToContact:'',
    selectedPaymentTerm:'',
    invoice_title: 'Invoice 1',
    invoice_number: '1',
    invoice_memo: '',
    items: [],
    contact_being_edited: '',
    item_being_edited: '',
    menuVisible: false,
    isActive: false,
    success: false,
    failure: false,
    searchIsActive: false,
    invoice_search_query: null,
    invoice_search_result: [],
    invoice_obj: Object,
    payments: undefined,
    paymentAmount :0,
    editInvoiceTerm: null,
    sessions: null,
    currentCompany: {},
    showExpiryDialog: false,
    currentPaymentLine: null,
    newInvoice : Object
};

const mutations = {
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, token, raw_token) {
        state.status = 'success'
        state.token = token
        state.raw_token = raw_token
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        state.status = '';
        state.token = '';
        state.raw_token = '';
        state.companies = '';
        state.selectedContact = '';
        state.selectedPaymentTerm = '';
        state.selectedDepositToContact ='';
        state.invoice_title = '';
        state.invoice_number = '';
        state.items = [];
        state.payments = [];
        state.currentCompany = {};
        router.go('/login')
    },
    selectContact(state, contact) {
        state.selectedContact = contact
    },
    selectDepositToContact(state, contact) {
        state.selectedDepositToContact = contact
    },
    pushItem(state, item) {
        state.items.push(item)
    },
    pushPayment(state, data) {
        let payment = data.payment;
        // create empty obj in array index;
        if (state.payments[data.index] === undefined) {
            state.payments[data.index] = {};
        }
        if (payment.method_name) {
            state.payments[data.index].method_name = payment.method_name;
        }
        if (payment.method_id) {
            state.payments[data.index].method_id = payment.method_id;
        }
        if (payment.account_id) {
            state.payments[data.index].account_id = payment.account_id;
        }
        if (payment.account_name) {
            state.payments[data.index].account_name = payment.account_name 
        }
        if (payment.amount) {
            state.payments[data.index].amount = payment.amount; 
        }
    },
    setItems(state, items) {
        state.items = items
    },
    removeItem(state, index) {
        state.items.splice(index, 1)
        // router.go(-1)
    },
    removePayment(state, index) {
        state.payments.splice(index, 1);
    },
    clearItems(state) {
        state.items = []
    },
    changeItem(state, data) {

        if (data.quantity != null) {
            state.items[data.index].quantity = data.quantity
        }

        if (data.discount != null) {
            state.items[data.index].discount = data.discount;
        }
        if (data.sale_price != null) {
            state.items[data.index].sale_price = data.sale_price;
        }

        if (data.name != null) {
            state.items[data.index].name = data.name;
        }

    },
    setItemLineIsDeleted(state, data) {
        // state.items[data.index] = {};
        // state.items[data.index].id = data.id;
        state.items.splice(data.index, 1)
        let item = {
            id : data.id,
            is_deleted: true
        };
        state.items.push(item)
        // state.items[data.index].is_deleted = true
    },
    clearPayments(state) {
        state.payments = []
    },
    setPaymentAmount(state, amount) {
        state.paymentAmount = amount
    },
    clearPaymentAmount(state) {
        state.paymentAmount = 0;
    },
    clearSelectedContact(state) {
        state.selectedContact = ''
    },
    clearSelectedDepositToContact(state) {
        state.selectedDepositToContact = ''
    },
    clearSelectedPaymentTerm(state) {
        state.clearSelectedPaymentTerm = ''
    },
    toggleMenu(state) {
        state.menuVisible = !state.menuVisible
        if(state.menuVisible == true) {
            state.isActive = true
        } else {
            setTimeout(() => {
                state.isActive = false
            }, 100)
        }
    },
    resetDrawer(state) {
        state.menuVisible = false
        state.isActive = false
    },
    set_company(state, company) {
        state.selected_company = company
        router.go('/')
        console.log('New Selected Company: ' + JSON.stringify(state.selected_company))
    },
    setCurrentCompany(state, company){
        this.state.showExpiryDialog = false;
        if (company.is_free){
            this.state.showExpiryDialog = true;
        }
        state.currentCompany = company;
    },
    setCompanies(state, companies) {
        state.companies = companies
    },
    set_invoice_details(state, invoice_details) {
        console.log(invoice_details)
        if(invoice_details.title) {
            state.invoice_title = invoice_details.title
        } else {
            state.invoice_title = 'Invoice 1'
        }

        if(invoice_details.number) {
            state.invoice_number = invoice_details.number
        } else {
            state.invoice_number = '1'
        }

        if(invoice_details.memo) {
            state.invoice_memo = invoice_details.memo
        } else {
            state.invoice_memo = ''
        }
    },
    clear_invoice_details(state) {
        state.invoice_title = ''
        state.invoice_number = ''
        state.invoice_memo = ''
    },
    set_contact_being_edited(state, contact) {
        state.contact_being_edited = contact
        console.log(state.contact_being_edited)
    },
    set_item_being_edited(state, item) {
        state.item_being_edited = item
        console.log(state.item_being_edited)
    },
    event_success(state) {
        state.success = true
        setTimeout(() => {
            state.success = false
        }, 4000)
    },
    event_failure(state) {
        state.failure = true
        console.error('Something went wrong!')
        setTimeout(() => {
            state.failure = false
        }, 4000)
    },
    set_failure_to_false(state) {
        state.failure = false
    },
    set_search_is_active(state) {
        state.searchIsActive = true
    },
    set_search_is_inactive(state) {
        state.searchIsActive = false
    },
    set_invoice_search_result(state, invoices) {
        state.invoice_search_result = invoices
    },
    clear_invoice_search_result(state) {
        state.invoice_search_result = []
    },
    set_invoice_search_query(state, invoices) {
        state.invoice_search_query = invoices
    },
    clear_invoice_search_query(state) {
        state.invoice_search_query = []
    },
    clear_items(state) {
        state.items = []
    },
    set_invoice_memo(state, memo) {
        state.invoice_memo = memo
    },
    clear_invoice_memo(state) {
        state.invoice_memo = ''
    },
    set_invoice_obj(state, obj) {
        state.invoice_obj = obj
    },
    clear_invoice_obj(state) {
        state.invoice_obj = null
    },
    set_invoice_number(state, invoice_number) {
        state.invoice_number = invoice_number
    },
    clear_invoice_number(state) {
        state.invoice_number = ''
    },
    setEditInvoiceTerm(state, editInvoiceTerm) {
        state.editInvoiceTerm = editInvoiceTerm;
    },
    clearEditInvoiceTerm(state){
        state.editInvoiceTerm = null
    },
    setSessions(state, sessions) {
        state.sessions = sessions;
    },
    setRawToken(state, rawToken) {
        state.raw_token = rawToken;
    },
    setUser(state, user) {
        state.user = user;
    },
    setCurrentPaymentLine (state, currentPaymentLine) {
        state.currentPaymentLine = currentPaymentLine
    } 
};

const actions = {
    setCurrentPaymentLine ({commit}, currentPaymentLine) {
        commit('setCurrentPaymentLine', currentPaymentLine);
    },
    setSessions({commit}, sessions) {
        commit('setSessions', sessions);
    },

    setCompanies({commit}, companies) {
        commit('setCompanies', companies);
    },
    setUser({commit}, user) {
        commit('setUser', user);
    },
    setRawToken({commit}, rawToken) {
        commit('setRawToken', rawToken);
    },
    setAuthSuccess({commit}, data) {
        commit('auth_success', data.authorization_token, data.raw_token);
    },
    setSelectedCompany({commit}, company) {
        commit('set_company', company);
    },
    login({commit}, user) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({
                url: 'login',
                data: user,
                method: 'POST'
            })
                .then(resp => {
                    const access_token = resp.data.session.access_token
                    const client_id = resp.data.session.client_id
                    const user = JSON.parse(JSON.stringify(resp.data.people))
                    const companies = JSON.parse(JSON.stringify(resp.data.companies))
                    this.state.selected_company = companies[0].id
                    this.state.user = user;
                    const session = resp.data.session;

                    commit('setSessions', session)
                    commit('setCompanies', companies);
                    commit('setCurrentCompany', companies[0]);

                    //Base64 token - client_id:access_token
                    var rawStr = client_id + ':' + access_token
                    var wordArray = cryptojs.enc.Utf8.parse(rawStr)
                    var base64 = cryptojs.enc.Base64.stringify(wordArray)
                    var authorization_token = 'Basic ' + base64;
                    var raw_token = base64

                    this.state.raw_token = base64

                    //Set localStorage items
                    localStorage.setItem('status', 'Logged in')
                    localStorage.setItem('token', authorization_token)
                    localStorage.setItem('companies', companies)
                    localStorage.setItem('raw_token', raw_token)

                    //Set Authorization to Base64 value
                    axios.defaults.headers.common['Authorization'] = authorization_token
                    commit('auth_success', authorization_token, raw_token)
                    resolve(resp)
                })
                .catch(err => {
                    console.log(err)
                    commit('auth_error')
                    localStorage.removeItem('token')
                    localStorage.removeItem('raw_token')
                    reject(err)
                })
        })
    },
    register({commit}, user) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({
                url: '/signup',
                data: user,
                method: 'POST'
            })
                .then(resp => {
                    // const token = resp.data.token
                    // const user = resp.data.user
                    // localStorage.setItem('token', token)
                    //
                    // axios.defaults.headers.common['Authorization'] = token
                    // commit('auth_success', token, user)
                    // resolve(resp)
                    console.log('Registration successful')
                    resolve(resp)
                })
                .catch(err => {
                    console.log(err)
                    reject(err)
                })
        })
    },
    logout({commit}) {
        return new Promise((resolve, reject) => {
            commit('logout')
            localStorage.removeItem('status')
            localStorage.removeItem('companies')
            localStorage.removeItem('token')
            localStorage.removeItem('raw_token')

            delete axios.defaults.headers['Authorization']
            resolve()
        })
    },
    set_invoice_details({commit}, invoice_details) {
        commit('set_invoice_details', invoice_details)
    },
    clear_invoice_details({commit}) {
        commit('clear_invoice_details')
    },
    set_contact_being_edited({commit}, contact) {
        commit('set_contact_being_edited', contact)
    },
    set_item_being_edited({commit}, item) {
        commit('set_item_being_edited', item)
    },
    selectContact({commit}, contact) {
        commit('selectContact', contact)
    },
    selectDepositToContact({commit}, contact) {
        commit('selectDepositToContact', contact)
    },
    pushItem({commit}, item) {
        commit('pushItem', item)
    },
    pushPayment({commit}, data){
        commit('pushPayment', data)
    },
    setItems({commit}, items) {
        commit('setItems', items)
    },
    setPaymentAmount({commit}, amount){
        commit('setPaymentAmount', amount)
    },
    clearItems({commit}) {
        commit('clearItems')
    },
    clearPayments({commit}) {
        commit('clearPayments')
    },
    clearSelectedContact({commit}) {
        commit('clearSelectedContact')
    },
    clearSelectedDepositToContact({commit}) {
        commit('clearSelectedDepositToContact')
    },
    clearSelectedPaymentTerm({commit}) {
        commit('clearSelectedPaymentTerm')
    },
    removeItem({commit}, indexof_item) {
        commit('removeItem', indexof_item)
    },
    removePayment({commit}, indexof_payment) {
        commit('removePayment', indexof_payment)
    },
    changeItem({commit}, data) {
        commit('changeItem', data)
    },
    setItemLineIsDeleted({commit}, data) {
        commit('setItemLineIsDeleted', data)
    },
    event_success({commit}) {
        commit('event_success')
    },
    event_failure({commit}) {
        commit('event_failure')
    },
    set_failure_to_false({commit}) {
        commit('set_failure_to_false')
    },
    set_search_is_active({commit}) {
        commit('set_search_is_active')
    },
    set_search_is_inactive({commit}) {
        commit('set_search_is_inactive')
    },
    set_invoice_search_query({commit}, invoices) {
        commit('set_invoice_search_query', invoices)
    },
    clear_invoice_search_query({commit}) {
        commit('clear_invoice_search_query')
    },
    set_invoice_search_result({commit}, invoices) {
        commit('set_invoice_search_result', invoices)
    },
    clear_invoice_search_result({commit}) {
        commit('clear_invoice_search_result')
    },
    clear_items({commit}) {
        commit('clear_items')
    },
    set_invoice_memo({commit}, memo) {
        commit('set_invoice_memo', memo)
    },
    clear_invoice_memo({commit}) {
        commit('clear_invoice_memo')
    },
    set_invoice_obj({commit}, obj) {
        commit('set_invoice_obj', obj)
    },
    clear_invoice_obj({commit}) {
        commit('clear_invoice_obj')
    },
    set_invoice_number({commit}, invoice_number) {
        commit('set_invoice_number', invoice_number)
    },
    clear_invoice_number({commit}) {
        commit('clear_invoice_number')
    },
    set_raw_token({commit}, raw_token) {
        commit('set_raw_token', raw_token)
    },
    clear_raw_token({commit}) {
        commit('clear_raw_token')
    },
    setEditInvoiceTerm({commit}, editInvoiceTerm) {
        commit('setEditInvoiceTerm', editInvoiceTerm)
    },
    clearEditInvoiceTerm({commit}) {
        commit('clearEditInvoiceTerm')
    },
    setCurrentCompany({commit}, company){
        commit('setCurrentCompany', company)
    }
};

const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

